export default {
    strict: true,
    fields: {
        class: {
            type: "string",
        },
        box: {
            type: "string",
        },
        condition: {
            type: "string",
        },
        numOfPallets: {
            type: "number",
        },
        capacity: {
            type: "number",
        },
    },
};
